import { SatService } from './../_services/satservice';
import { Component, OnInit } from '@angular/core';
import { Sat_Report } from '../sat/sat';

@Component({
  selector: 'app-satlistview',
  templateUrl: './satlistview.component.html',
  styleUrls: ['./satlistview.component.css', '../app.component.less']
})
export class SatlistviewComponent implements OnInit {
_satreports : Sat_Report[]; 
  constructor(private satservice : SatService) { }

  ngOnInit(): void {

    console.log("Entered SATREPORTS");
        this.satservice.getSat_Reports().subscribe(resp =>{ 
          
      this._satreports = resp ; 

      console.log(resp);

  });
  }

}
